import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addDownload, getDownloadData } from "../../../store/download/reducer";
import { SlClose } from "react-icons/sl";
import Button from "../../common/Button";

export const AddDownloads = ({ modalOpen, setModalOpen }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    setTitle("");
    setDescription("");
    setUploadedFiles([]);
    setModalOpen(false);
  };
  // Handle file selection
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files); // Converts FileList to an array
    setUploadedFiles((prevFiles) => [...prevFiles, ...selectedFiles]); // Appends new files to the state
  };

  // Remove selected file
  const handleDeleteFile = (fileIndex) => {
    setUploadedFiles((prevFiles) =>
      prevFiles.filter((file, index) => index !== fileIndex),
    );
  };

  // Frontend (AddDownloads Component)

  const handleSubmit = () => {
    if (!title || !description || uploadedFiles.length === 0) {
      alert("Please fill all fields.");
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);

    // Append each file to FormData with the field name 'files' (should match the backend field name)
    uploadedFiles.forEach((file) => {
      formData.append("file", file);
    });

    dispatch(addDownload(formData))
      .then((response) => {
        // Check the response to confirm it was successful
        if (response && response.data) {
          setTitle("");
          setDescription("");
          setUploadedFiles([]);
          setModalOpen(false);
          dispatch(getDownloadData());
        } else {
          throw new Error("Unexpected response format");
        }
      })
      .catch((error) => {
        console.error("Error in file upload:", error);
        alert("Something went wrong. Please try again later.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 max-w-lg">
            <h2 className="text-2xl font-bold text-[#1e81b0] mb-4">
              Add File Details
            </h2>

            {/* Title Input */}
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">
                Title
              </label>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full border-gray-300 rounded-md border-2 focus:outline-none focus:ring-2 focus:ring-[#1e81b0] "
              />
            </div>

            {/* Description Input */}
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">
                Description
              </label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full border-gray-300 rounded-md border-2 focus:outline-none focus:ring-2 focus:ring-[#1e81b0] "
              />
            </div>

            {/* File Upload */}
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">
                Upload Files
              </label>
              <input
                type="file"
                onChange={handleFileChange}
                accept=".doc,.docx,.txt,.pdf,.jpg,.jpeg,.png,.gif,.bmp,.ppt,.pptx,.zip,.rar"
                multiple
                className="w-full text-sm text-gray-500 bg-gray-50 rounded-md shadow-sm border border-gray-300"
              />
            </div>

            {/* File Preview */}
            {uploadedFiles.length > 0 && (
              <div className="mb-4">
                <h3 className="font-medium text-gray-700">Selected Files:</h3>
                <ul className="list-disc ">
                  {uploadedFiles.map((file, index) => (
                    <li
                      key={index}
                      className="text-gray-700 my-2 text-sm flex justify-between items-center border-2 border-gray-400 rounded-md  px-4 py-1"
                    >
                      <span>{file.name}</span>
                      <Button
                        onClick={() => handleDeleteFile(index)}
                        type="secondary"
                        className="ml-4  text- hover:scale-105 duration-300"
                      >
                        <SlClose className="text-xl " />
                      </Button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="flex justify-between">
              <Button
                type="secondary"
                onClick={handleCloseModal}
                className="px-4 py-2 text-black"
              >
                Cancel
              </Button>
              {loading === true ? (
                <Button
                  type="primary"
                  onClick={handleSubmit}
                  disabled
                  className="px-4 py-2 "
                >
                  Please Wait...
                </Button>
              ) : (
                <Button
                  type="primary"
                  onClick={handleSubmit}
                  className="px-4 py-2 "
                >
                  Submit
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
